module.exports = __webpack_public_path__ + "static/media/totoro.50fa5a1e.jpg";